import { application } from '@core/controllers/app';

application.register('hellgate-settlements--reports',
  require('./hellgate_settlements/reports_controller').default);
